export default [
	{
		type: "uni",
		id: 1,
		items: [
			{
				id: 1,
				text: "The lecturer is dedicated and motivated.",
			},
			{
				id: 2,
				text: "The lecturer presents the content appropriately.",
			},
			{
				id: 3,
				text: "I am able to follow the pace of the lecturer.",
			},
			{
				id: 4,
				text: "The lecturer provides a good learning and working atmosphere.",
			},
			{
				id: 5,
				text: "The lecturer provides the opportunity to ask questions.",
			},
			{
				id: 6,
				text: "The lecturer is always well prepared.",
			},
			{
				id: 7,
				text: "The lecturer is able to make the content accessible.",
			},
			{
				id: 8,
				text: "It is important to the lecturer that the participants benefit from the course.",
			},
			{
				id: 9,
				text: "The lecturer teaches the course in an interesting way.",
			},
			{
				id: 10,
				text: "The materials and the media used by the lecturer are very helpful.",
			},
			{
				id: 11,
				text: "The range of support offered by the lecturer (e.g. office hours) is adequate.",
			},
			{
				id: 12,
				text: "The educational objectives are well defined from the beginning.",
			},
			{
				id: 13,
				text: "The course is well structured and comprehensible.",
			},
			{
				id: 14,
				text: "The structure of the content is logical/easy to follow.",
			},
			{
				id: 15,
				text: "I gain important insights in the course.",
			},
			{
				id: 16,
				text: "I further develop important competencies in the course.",
			},
			{
				id: 17,
				text: "The competencies acquired in the course are of great relevance for my academic development.",
			},
			{
				id: 18,
				text: "The module helps me prepare for my professional life.",
			},
			{
				id: 19,
				text: "The module makes finding a good job after my studies easier.",
			},
			{
				id: 20,
				text: "Exchanging ideas with other students during the course is helpful for attaining my goals.",
			},
			{
				id: 21,
				text: "The course encourages me to think about my future career.",
			},
			{
				id: 22,
				text: "The module leads me to feel confident and inspired about my future.",
			},
			{
				id: 23,
				text: "Overall, this is a good course.",
			},
			{
				id: 24,
				text: "I learn a lot in this course.",
			},
			{
				id: 25,
				text: "The course fulfills my expectations.",
			},
			{
				id: 26,
				text: "I would recommend the course.",
			},
		],
	},
	{
		type: "text",
		id: 2,
		items: [
			{
				id: 27,
				text: "Further remarks",
			},
		],
	},
];
